import { EActionTypes } from '../../constants/actionTypes/estimation';
import { TReduxActions } from '../../types/redux';
import { IEstimationStore } from '../../types/estimation/types';

const initialState: IEstimationStore = {
  isError: false,
  isFetching: false,
  data: null,
};

export function estimationReducer(state = initialState, action: TReduxActions): IEstimationStore {
  switch (action.type) {
    case EActionTypes.GET_ESTIMATION_REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case EActionTypes.GET_ESTIMATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isError: false,
        data: action.payload,
      };

    case EActionTypes.GET_ESTIMATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        isError: true,
      };

    case EActionTypes.GET_ESTIMATION_CLEAR:
      return initialState;

    default:
      return state;
  }
}
